import { z } from "zod";
export const AuditEventView = z.object({
    id: z.number().int(),
    occurredAt: z.string().datetime(),
    actorUserId: z.string().nullable(),
    actorLabel: z.string(),
    actorName: z.string().nullable(), // joined from User when actorUserId is set
    action: z.string(),
    targetType: z.string(),
    targetId: z.string().nullable(),
    before: z.unknown().nullable(),
    after: z.unknown().nullable(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
});
export const AuditQuery = z.object({
    action: z.string().optional(),
    targetType: z.string().optional(),
    targetId: z.string().optional(),
    actorUserId: z.string().optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export const AuditListResponse = z.object({
    data: z.array(AuditEventView),
    total: z.number().int(),
});
//# sourceMappingURL=audit.js.map